class IntersectingSection extends window.BAO.CustomElement() {
  static get requiredAttributes () {
    return ['data-classname-to-apply', 'data-threshold']
  }

  static get requiredElements () {
    return ['section']
  }

  connectedCallback () {
    super.connectedCallback()

    if (!this.sectionEl) return

    if (!this.isIntersectionObserverSupported) {
      this.applyActiveClassName()
      return
    }

    this.intersectionObserverCallback = this.intersectionObserverCallback.bind(
      this,
    )

    // eslint-disable-next-line compat/compat
    this.observer = new IntersectionObserver(
      this.intersectionObserverCallback,
      {
        threshold: this.dataset?.threshold,
      },
    )
    this.observer.observe(this.sectionEl)
  }

  intersectionObserverCallback (entries) {
    const entry = entries?.[0]
    if (!entry?.isIntersecting) return
    this.applyActiveClassName()
    this.observer.disconnect()
  }

  applyActiveClassName () {
    this.sectionEl.classList.add(this.dataset?.classnameToApply)
  }

  get sectionEl () {
    return this.els?.section?.element
  }

  /**
   * @returns {boolean} Whether or not IntersectionObserver is supported by the browser
   */
  get isIntersectionObserverSupported () {
    return `IntersectionObserver` in window
  }
}

if (!customElements.get('intersecting-section')) {
  customElements.define('intersecting-section', IntersectingSection)
}
